// extracted by mini-css-extract-plugin
export default {"header":"header_header__YJ7m2","wrapper":"header_wrapper__8BnRe","hoverText":"header_hoverText__6Nbrj"};